const eggs = document.querySelectorAll(".easter-egg");

function positionEggs() {
  console.log("Positioning");
  eggs.forEach(function (egg) {
    const blockId = egg.classList[1];
    const block = document.querySelector(`.popup.${blockId}`);
    const targetSelector = egg.dataset.targetSelector;
    const section = document.querySelector(
      `${targetSelector}`
    );

    if (section) {
      const sectionRect = section.getBoundingClientRect();
      let eggTop = 0;
      let eggLeft = 0;
      if(window.innerWidth < 768) {
        eggTop = parseInt(egg.dataset.mobileY, 10) || 0;
        eggLeft = parseInt(egg.dataset.mobileX, 10) || 0;
      }else {
        eggTop = parseInt(egg.dataset.desktopY, 10) || 0;
        eggLeft = parseInt(egg.dataset.desktopX, 10) || 0;
      }
      const sectionTop = sectionRect.top + window.scrollY;
      const sectionLeft = sectionRect.left + window.scrollX;
      egg.style.top = `${sectionTop + eggTop}px`;
      egg.style.left = `${sectionLeft + eggLeft}px`;
    }
  });
}

// For images and other resources
document.addEventListener('DOMContentLoaded', function() {
  positionEggs();
  document.body.setAttribute('data-window-width', window.innerWidth);
});

window.addEventListener('resize', ()=>{
  if(window.innerWidth != document.body.getAttribute('data-window-width')) {
    setTimeout(() => {
      positionEggs();
    }, 1000);
    document.body.setAttribute('data-window-width', window.innerWidth);
  }
});

document.querySelectorAll(".easter-egg").forEach(function (egg) {
  egg.addEventListener("click", function (event) {
    event.preventDefault();
    const popup = document.querySelector(`.popup.${this.classList[1]}`);
    popup.style.display = "block";
    setTimeout(() => {
      popup.style.opacity = 1;
    }, 10);
    document.body.style.overflow = "hidden";

    var end = Date.now() + 6 * 1000;

    var colors = ["#ff8da1", "#ffffff"];
    let zIndex = 10002;

    (function frame() {
      confetti({
        particleCount: 2,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: colors,
        zIndex: zIndex,
      });
      confetti({
        particleCount: 2,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: colors,
        zIndex: zIndex,
      });

      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  });
});
document.querySelectorAll(".popup").forEach(function (popup) {
  popup.addEventListener("click", function (event) {
    if (
      !event.target.closest(".popup-content") &&
      this.style.display === "block"
    ) {
      closePopup(this);
    }
  });
});

function closePopup(popup) {
  popup.style.opacity = 0;
  setTimeout(() => {
    popup.style.display = "none";
  }, 300);
  document.body.style.overflow = "";
}

const popups = document.querySelectorAll(".popup");
document.addEventListener("keydown", function (event) {
  if (event.key === "Escape") {
    popups.forEach(function (popup) {
      if (popup.style.display === "block") {
        closePopup(popup);
      }
    });
  }
});
